module.exports = __webpack_public_path__ + "static/media/tipo1.fb180b65.png";